"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CloseIcon = _styledComponents["default"].svg.withConfig({
  displayName: "Close__CloseIcon",
  componentId: "mbyevk-0"
})(["width:12px;transition:fill 0.2s ease;fill:currentColor;"]);

var Close = function Close(_ref) {
  var className = _ref.className;
  return _react["default"].createElement(CloseIcon, {
    className: className,
    viewBox: "0 0 24 24",
    width: 12
  }, _react["default"].createElement("path", {
    d: "M11.96 8a.54.54 0 0 1 .08 0L19.8.17a.54.54 0 0 1 .77 0l3.27 3.3c.21.22.21.56 0 .78L16.18 12l7.66 7.76c.2.21.2.56 0 .78l-3.27 3.3a.54.54 0 0 1-.77 0L12.04 16a.54.54 0 0 1-.08 0L4.2 23.85a.54.54 0 0 1-.77 0L.16 20.54a.56.56 0 0 1 0-.78L7.82 12 .16 4.25a.56.56 0 0 1 0-.78L3.43.16a.54.54 0 0 1 .77 0L11.96 8z"
  }));
};

Close.propTypes = {
  className: _propTypes["default"].string
};
var _default = Close;
exports["default"] = _default;